import * as Yup from 'yup';
export function getPostInitialValues(editResponse) {
  let displayCostToMarket
  if (editResponse && !editResponse?.displayCostToMarket) {
    displayCostToMarket = false
  } else {
    displayCostToMarket = true
  }
    return {
      maxEditQty: editResponse?.lotDetails?.originalQty || 540,
      editRecuurenceQty: (editResponse?.lotDetails?.lotPostingOption === 'SINGLE' ? editResponse?.lotDetails?.totalQty : editResponse?.lotDetails?.qtyPerLot) || 540,
      //Need
      desiredPrice: editResponse?.targetPrice || '',
      //Inventory
      basePrice: editResponse?.minDeliveredPrice || '',
      buyNowDeliveredPrice: editResponse?.buyNowDeliveredPrice || '',
      cpuPrice: editResponse?.buyNowPickupPrice || '',
    }
}

const VALIDATION_SCHEMA = () => {
  let schemaAttributes = {

  }
  return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };